// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___PUd9o","body-container":"style__body-container___1XbZY","imgContainer":"style__imgContainer___MO2L5","cardImg":"style__cardImg___2uluy","headerWithButton":"style__headerWithButton___3aFHG","header":"style__header___15ipz","applyNowButtonContainer":"style__applyNowButtonContainer___2VHjZ","applyButton":"style__applyButton___1ctgV","closeContainer":"style__closeContainer___2FD0J"};


//////////////////
// WEBPACK FOOTER
// ./src/purchases/smallApplicationBanner/style.scss
// module id = 1265
// module chunks = 0